module.exports = __webpack_public_path__ + "static/media/gabriel.c40ad155.jpg";